/**
 *
 * @param {{className: string, title: string, body: string, button?: React.ReactNode, cta: {title: string, callback: () => void}}} props
 */
export const AccountBanner = (props) => {
  return (
    <div className={`w-full ${props.className}`}>
      <div className={'flex flex-col justify-between gap-4 p-4 md:flex-row'}>
        <div className={'my-auto flex flex-col'}>
          <h4 className={'h4 font-bold'}>{props.title}</h4>
          {props.body && <p>{props.body}</p>}
        </div>
        <div>
          {props.button ? (
            props.button
          ) : (
            <button onClick={props?.cta?.callback} className={'btn btn-solid-black btn-md justify-center'}>
              {props.cta.title}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
